<template>
  <div>
    <div class="search">
      <div class="search-item" v-for="(item, index) in searchData" :key="index">
        <!-- 标题 -->
        <span class="label">
          {{ item.title + ": " }}
        </span>
        <!-- 控件 -->
        <!-- 输入框 -->
        <!-- <el-input
          v-model="searchParams[item.key]"
          v-if="item.type === 'input'"
          :placeholder="item.placeholder"
        ></el-input> -->

        <!-- 
          下拉框：
          multiple 单选或者多选
          clearable 开启清空按钮
          filterable 开启搜索功能
          时间选择框：
          type 有type属性的组件可以使用传递的值
          range-separator，start-placeholder，end-placeholder为时间输入框的属性
         -->
        <component
          :is="`el-${item.template}`"
          v-model="searchParams[item.key]"
          :placeholder="item.placeholder"
          :multiple="item.multiple || false"
          :clearable="true"
          :filterable="true"
          :type="item.type || null"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
          <component
            v-if="item.template === 'select'"
            :is="'el-option'"
            v-for="selectItem in item.selectList"
            :value="selectItem.value"
            :label="selectItem.name"
            :key="selectItem.value"
          ></component>
        </component>

        <!-- 下拉框  multiple控制是否多选 -->
        <!-- <el-select
          v-model="searchParams[item.key]"
          v-if="item.type === 'select'"
          :placeholder="item.placeholder"
          :multiple="item.multiple || false"
          :clearable="true"
          :filterable="true"
        >
          <el-option
            v-for="selectItem in item.selectList"
            :value="selectItem.value"
            :label="selectItem.name"
            :key="selectItem.value"
          ></el-option>
        </el-select> -->
      </div>

      <div class="search-btn">
        <el-button>重置</el-button>
        <el-button type="primary" @click="search">查询</el-button>
        <slot name="searchBtn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    /**
     * searchData的item格式为
     * {
     *  title: "组合处理编号",
     *  key: "assembleNo",
     *  template: "input",
     *  placeholder: "请输入组合处理编号",
     * }
     * template 控制控件的类型，必须按照element的组件标签名称
     * key 为查询的字段
     *
     * 如果控件类型为select，则需要提供selectList，格式为
     * {
     *   name:'',
     *   value:''
     * }
     * 如果控件为多选select，则额外传入一个 multiple:Boolean 默认为false 单选
     * select默认开启了清空和搜索功能
     *
     */

    searchData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchParams: {},
    };
  },

  created() {},

  methods: {
    search() {
      this.$emit("search", this.searchParams);
    },
    clear() {},
  },
};
</script>

<style scoped lang="less">
.search {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 20px;
  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .label {
      min-width: 100px;
      text-align: right;
      margin-right: 5px;
    }
    .el-input {
      width: 200px;
    }
    .el-select {
      width: 200px;
    }
  }

  &-btn {
    margin-left: 20px;
  }
}
</style>
